<ion-header *ngIf="modal"
            class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ion-title *ngIf="!message.id"
                   [innerHTML]="'MESSAGE_CREATE' | translate"></ion-title>
        <ion-title *ngIf="message.id"
                   [innerHTML]="'MESSAGE_EDIT' | translate"></ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="backClicked()">
                <ion-icon slot="icon-only"
                          color="dark"
                          name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<form method="post"
      #f="ngForm"
      role="form"
      class="form-horizontal edit-message-{{message.id}}">

    <ion-item [ngClass]="{'has-value': (message.hasValue() || displayBigTextarea) }"
              class="form-content">
        <ion-grid class="ion-no-padding">

            <ion-row class="row-message ion-no-padding"
                     [ngClass]="{'has-error': validate && validationErrors['message']}">

                <ion-col class="ion-no-padding">

                    <ion-textarea #messageTextarea
                                  ieTextareaFix
                                  placeholder="{{ 'MESSAGES_NEW_MESSAGE_PLACEHOLDER' | translate }}"
                                  name="message"
                                  inputmode="text"
                                  spellcheck="false"
                                  autocapitalize="off"
                                  id="messageTextarea"
                                  maxLength="10000"
                                  autoGrow="true"
                                  (click)="displayBigTextarea = true"
                                  (ionFocus)="plt.checkResize()"
                                  (ionBlur)="plt.checkResize(false)"
                                  [(ngModel)]="message.message">
                    </ion-textarea>

                    <div class="action-buttons">

                        <ion-spinner *ngIf="sending"
                                     name="dots"></ion-spinner>

                        <!-- <div class="action-buttons-wrap"
                             [hidden]="sending">

                            <div class="dropzone-file"
                                 *ngIf="!newsfeed.file">
                                <ng-container>
                                    <ion-thumbnail slot="start">
                                        <dropzone [message]="''"
                                                  [config]="dropZoneConfigExtended"
                                                  (success)="onUploadSuccess($event, true)"
                                                  (error)="onUploadError($event)"
                                                  (sending)="onSending($event)">
                                        </dropzone>
                                    </ion-thumbnail>
                                </ng-container>
                            </div>
                        </div> -->

                    </div>

                </ion-col>

            </ion-row>

            <div class="message-controls">
                <ion-row class="row-message-error"
                         *ngIf="validate && validationErrors['message']">
                    <ion-col>
                        <span class="error-message">
                            {{ validationErrors['message'] }}
                        </span>
                    </ion-col>
                </ion-row>

                <!-- <ion-row class="ion-no-padding"
                         *ngIf="message.file || uploading">
                    <ion-col class="ion-no-padding">
                        <div class="file-list">

                            <span *ngIf="uploading"
                                  class="uploading">
                                <div class="uploading-spinner">
                                    <ion-spinner></ion-spinner>
                                </div>
                                <div class="progress-container"
                                     *ngIf="uploading">
                                    <progress class="progress"
                                              max="100"
                                              value="{{ progress }}"></progress>
                                </div>
                            </span>

                            <span *ngIf="message.file"
                                  class="file-link">
                                <svg-icon [applyClass]="true"
                                          [src]="'/assets/icons/profile/pdf.svg'">
                                </svg-icon>
                                <span class="file-name">{{ message.filename }}</span>
                                <span class="remove-file"
                                      (click)="deleteFile()"></span>
                            </span>

                        </div>
                    </ion-col>
                </ion-row> -->

                <ion-row *ngIf="!modal"
                         class="form-button ion-no-padding">
                    <!-- <ion-col class="ion-no-padding">
                            <span *ngIf="validate && validationErrors['message']"
                                  class="error-message">
                                {{ validationErrors['message'] }}
                            </span>
                        </ion-col> -->

                    <ion-col class="ion-no-padding ion-text-right">
                        <ion-button *ngIf="message.id"
                                    class="btn-close"
                                    (click)="backClicked(false)">
                            {{ 'BUTTON_CANCEL' | translate }}
                        </ion-button>
                        <ion-button color="primary"
                                    id="post-message-button"
                                    (click)="postMessage(f.form.valid)">
                            {{ 'BUTTON_SAVE' | translate }}
                        </ion-button>
                    </ion-col>

                </ion-row>

            </div>

        </ion-grid>
    </ion-item>
</form>

<ion-footer *ngIf="modal">
    <ion-row class="action-buttons two ion-no-padding">
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button class="btn-close"
                        (click)="backClicked()">
                {{ 'BUTTON_CANCEL' | translate }}
            </ion-button>
        </ion-col>
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button color="primary"
                        (click)="postMessage(f.form.valid)">
                {{ 'BUTTON_SAVE' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>